import { render, staticRenderFns } from "./AddTagPage.vue?vue&type=template&id=4af6d545&"
import script from "./AddTagPage.vue?vue&type=script&lang=js&"
export * from "./AddTagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports